
import { CalculatedField } from "@/models/calculated-field";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { CalculatedFieldService } from "@/services/calculated-field-service";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			fields: [] as CalculatedField[],
			selectedRows: [] as CalculatedField[]
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
		value: {
			type: Object as ()=>Dossier,
			required: true
		},
	},
	computed: {
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "ID",
					width: "40px",
				},
				{
					name: "Tabel",
					property: "Table",
					width: "200px"
				},
				{
					name: "Naam",
					property: "Name",
					width: "200px"
				},
				{
					name: "Return type",
					property: "ReturnType",
					width: "200px"
				}
			];
		},
		selectedItem():CalculatedField | null {
			if (this.selectedRows.length != 1) {
				return null;
			}
			return this.selectedRows[0];
		}
	},
	methods: {
		add(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/calculated-fields/new`);
		},
		edit(){
			if (!this.selectedItem) return;
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/calculated-fields/edit/${this.selectedItem.ID}`);
		},
		async remove(){
			let result = await this.$wf.confirm(`Weet je zeker dat je ${this.selectedRows.length} item(s) wilt verwijderen`, "Ja", "Nee");
			if (!result) return;
			for (let item of this.selectedRows){
				await CalculatedFieldService.deleteField(this.value.id, item);
			}
			this.selectedRows = [];
			this.fetch();
		},
		async fetch(){
			this.fields = await CalculatedFieldService.getAllFields(this.value.id);
		},
		compare(s1:CalculatedField, s2:CalculatedField):boolean{
			return s1.ID == s2.ID;
		}
	},
	mounted(){
		this.fetch();
	}
});
